export default "__VITE_ASSET__75edd42a__"